export const USER = 'user';

export const LOGIN = 'login';

export const ACCOUNT = 'account';

export const FORGOT_PASSWORD = 'forgot-password';

export const RESET_PASSWORD = 'reset-password';

export const CHANGE_PASSWORD = 'change-password';

export const ADMIN = 'admin';

export const DASHBOARD = 'dashboard';

export const EDIT = 'edit';

export const ADD = 'add';

export const UPDATE = 'update';

export const DETAILS = 'details';

export const USERS = 'users';

export const CATEGORY = 'categories';

export const CLASSES = 'classes';

export const EVENTS = 'events';

export const ARTICLES = 'articles';

export const SUBSCRIPTION = 'subscriptions';

export const CHALLANGES = 'challanges';

export const CLUB = 'club';





